<template>
<div class="bg-light">
  
  
  <Banner
    title="Logistics"
    pricing="false"
    level="1"
    bg-color="#fff"
    class="sticky-top"
    />
  
  
  <b-container
    class="text-light text-center p-5"
    style="background-color: #08034c;"
    fluid
    >
    <b-row>
      <b-col>
	<div class="pt-4 pb-5">
	  <b-img :src="require('../assets/trinity_logistics.png')"
		 class="mb-5"
		 style="width: 116px;" />
	  <h1>Trinity Logistics
	    <br>Connects All your Systems
	    <br>and gives you
	    <br>End to End Visibility of All Your Data
	  </h1>
	</div>
	<div class="text-left mx-auto d-inline-block">
	  <p class="mb-5">
	    Connect all the data across all your locations, applications and databases.
	    <br>Track every event for every package.
	    <br>Full status of every package combined from different systems
	  </p>
	  <p class="mb-5">For Maximum SecurityYou can keep Everything InHouse</p>
	  <p class="mb-5">View and Control any information from Dashboards</p>
	  <ul>
	    <li>Management Overview Dashboards</li>
	    <li>Worker Specific Dashboards</li>
	    <li>Customer Dashboards</li>
	  </ul>
	</div>
      </b-col>
    </b-row>
  </b-container>
  
  
  
  <b-container class="p-5 bg-white"
	       fluid>
    <b-row>
      <b-col>
	<div class="py-5 text-center">
	  <h1>Live Data Dashboards<br> with data from across any and all of your systems.</h1>
	</div>
      </b-col>
    </b-row>
    <!--b-row>
      <b-col cols="2"
	     class="text-center">
	<div>
	  <div>
	    <b-img :src="require('../assets/71.png')"
		   class="rounded-circle"
		   style="height: 86px;"/>
	  </div>
	  <div>
	    <span class="gmx-p">CEO</span>
	  </div>
	</div>
	<div>
	  <div>
	    <b-img :src="require('../assets/79.png')"
		   class="rounded-circle"
		   style="height: 86px;"/>
	  </div>
	  <div>
	    <span class="gmx-p">Sales</span>
	  </div>
	</div>
	<div>
	  <div>
	    <b-img :src="require('../assets/7.png')"
		   class="rounded-circle"
		   style="height: 86px;"/>
	  </div>
	  <div>
	    <span class="gmx-p">Packer</span>
	  </div>
	</div>
	<div>
	  <div>
	    <b-img :src="require('../assets/40.png')"
		   class="rounded-circle"
		   style="height: 86px;"/>
	  </div>
	  <div>
	    <span class="gmx-p">Truck Driver</span>
	  </div>
	</div>
      </b-col>
      <b-col cols="4">
	<div class="gmx-p">
	  <p class="font-weight-bold">Trinity Dashboard Examples</p>
	  <ul style="list-style-type:none;">
	    <li>Revenue, Costs, Profit</li>
	    <li>Shipments</li>
	    <li>Cost of Goods Sold</li>
	    <li>Average Loading Time</li>
	    <li>Average Loading Weight</li>
	    <li>Delivery Status %</li>
	    <li>Deliveries by Country</li>
	    <li>Average Delivery Time</li>
	    <li>Incoming Products</li>
	    <li>Stock Levels</li>
	    <li>Current Orders</li>
	    <li>Overdue Orders</li>
	    <li>Upcoming Deadlines</li>
	    <li>Shipping Time</li>
	    <li>Order Accuracy</li>
	    <li>Delivery Time</li>
	    <li>Location of Equipment</li>
	    <li>Employee Availability</li>
	    <li>Room Temperatures</li>
	    <li>Energy Usage</li>
	    <li>Humidity Levels</li>
	  </ul>
	</div>
      </b-col>
      <b-col cols="6">
	<b-img :src="require('../assets/dashboard-example-1.png')" fluid />
      </b-col>
    </b-row-->
    <b-row>
      <b-col>
	<div class="text-center">
	  <b-img :src="require('../assets/dashboards_logistics.png')" fluid />
	</div>
      </b-col>
    </b-row>
  </b-container>


  
  <AllSystemsInHouse />


  
  <GmxFooter />


  
</div>
</template>

<script>
import Banner from '@/components/gmx-banner.vue';
import GmxFooter from '@/components/footer.vue';
import AllSystemsInHouse from '@/components/all-systems-in-house.vue';
import * as log from 'loglevel';
export default {
    name: "Logistics",
    components: {
	Banner,
	GmxFooter,
	AllSystemsInHouse
    },
    methods: {
	img: function (image) {
	    require(image)
	}
    }
}
</script>

<style>
.bottom-btn-wrapper {
    margin-top: 390px;
}
.container-bg {
    background-image: url("../assets/logistics_image_full.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 0 -150px;
    height: 480px;
}
</style>
